module.exports = __webpack_public_path__ + "static/gr-skyline-75e1e213361fdfc172482d34f0f380d4.png";